import { render, staticRenderFns } from "./Instrument.vue?vue&type=template&id=35b510a3&"
import script from "./Instrument.vue?vue&type=script&lang=js&"
export * from "./Instrument.vue?vue&type=script&lang=js&"
import style0 from "./Instrument.vue?vue&type=style&index=0&id=35b510a3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports